export function getLettWorkerBaseUrl() {
  return (process.env.REACT_APP_LETT_WORKER_URL || '').replace(/\/+$/, '');
}

const ROBOKASSA_PAYMENT_URL = 'https://auth.robokassa.ru/Merchant/Index.aspx';

export function getAccountWebSubscription(user) {
  const raw = user?.publicMetadata?.webSubscription;
  if (!raw || typeof raw !== 'object') return null;

  const activeUntil = raw.activeUntil ? new Date(raw.activeUntil) : null;
  const rawPlanMonths = Number(raw.planMonths);
  const planMonths = [3, 6, 12].includes(rawPlanMonths) ? rawPlanMonths : null;

  if (!(activeUntil instanceof Date) || Number.isNaN(activeUntil.valueOf())) {
    return null;
  }

  return {
    activeUntil,
    planMonths,
    isActive: activeUntil > new Date(),
    startedAt: raw.startedAt ? new Date(raw.startedAt) : null,
    purchasedAt: raw.purchasedAt ? new Date(raw.purchasedAt) : null,
    invoiceId: typeof raw.invoiceId === 'string' ? raw.invoiceId : null,
    amount: typeof raw.amount === 'string' ? raw.amount : null,
    source: typeof raw.source === 'string' ? raw.source : null,
    lastPaymentStatus:
      typeof raw.lastPaymentStatus === 'string' ? raw.lastPaymentStatus : null,
    isTest: raw.isTest === true,
  };
}

export function redirectToRobokassa(paymentParams) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = ROBOKASSA_PAYMENT_URL;
  form.style.display = 'none';

  Object.entries(paymentParams).forEach(([key, value]) => {
    if (value == null || value === '') return;

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = String(value);
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}

export async function createRobokassaPayment({ clerkUserId, clerkSessionId, email, planMonths }) {
  const baseUrl = getLettWorkerBaseUrl();

  if (!baseUrl) {
    throw new Error('REACT_APP_LETT_WORKER_URL is not configured.');
  }

  const response = await fetch(`${baseUrl}/payments/robokassa/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      clerkUserId,
      clerkSessionId,
      email,
      planMonths,
    }),
  });

  const payload = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(payload?.error || 'Failed to create Robokassa invoice.');
  }

  return payload;
}
